const state = {
  showLeftMenu: true,
  globalLoading: true,
  menus: [],
  rules: [],
  users: {},
  userGroups: [],
  organizes: [],
  breadcrumb: [],
  leftmenu: true,
  eventLimitAttrItemAttr: [],
  eventLimitAttrItem: [],
  multipleSelectionAll: []
}

export default state